import { combineReducers } from '@reduxjs/toolkit';
import { createAnalyticsMiddleware } from '@consolidocs-ui/analytics';
import { baseApi } from '@consolidocs-ui/data-access';
import { toastReducer } from '@consolidocs-ui/utils';

// See apps/main's rootReducer: register the shared instance itself rather than
// whichever API module happens to be imported here.
const rootReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  toast: toastReducer,
});

export const middleware = [
  baseApi.middleware,
  // Records each mutation as an `Action Performed` analytics event.
  createAnalyticsMiddleware({ [baseApi.reducerPath]: 'backend' }),
];

export default rootReducer;
